













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class TopTag extends Vue {
  @Prop({ default: 0 }) topValue!: number;
}
